// import MD5 from 'crypto-js/md5';
// import env from 'lib/env';

export default function bookConfirmationExternals(input) {
  logRokt(input.user, input.receipt);
  logFacebook();
  // logSaasquatch(input.user);
}

function logRokt(user, receipt) {
  // Note: I didn't include the ID div from the example yet.
  var js = document.createElement("SCRIPT");
  js.type = "text/JavaScript";
  js.async = true;
  js.src = "https://apps.rokt.com/" +
    "?id=c9dc7d06fb1e4fc6a0f654c14c781722" +
    "&bhid=c9dc7d06fb1e4fc6a0f654c14c781722-b" +
    "&email=" + user.email +
    "&value=" + receipt.finalPrice +
    "&hidewidget=y" +
    "&v=" + Math.floor(Math.random() * 999).toString();
  var p = document.getElementsByTagName("script")[0]; p.parentNode.insertBefore(js, p);
}

function logFacebook() {
  var _fbq = window._fbq || (window._fbq = []);
  if (!_fbq.loaded) {
    var fbds = document.createElement('script');
    fbds.async = true;
    fbds.src = '//connect.facebook.net/en_US/fbds.js';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(fbds, s);
    _fbq.loaded = true;
  }
  window._fbq = window._fbq || [];
  window._fbq.push(['track', '6018320920886', {'value':'0.00','currency':'USD'}]);
}

// function logSaasquatch(user) {
//   if (user.id) {
//     var _sqh = _sqh || [];
//     _sqh.push(['init', {
//       tenant_alias: env().RS_TENANT_ALIAS,
//       account_id: user.id,
//       payment_provider_id: null,
//       user_id: user.id,
//       email: user.email,
//       first_name: user.firstname,
//       last_name: user.lastname,
//       userReferralCode: MD5(user.email).toString(),
//       jwt: user.jwt
//     }]);
//     (function(){function l(){var s=document.createElement("script");s.type="text/javascript";s.async=true;s.src=location.protocol+"//d2rcp9ak152ke1.cloudfront.net/assets/javascripts/squatch.min.js";var t=document.getElementsByTagName("script")[0];t.parentNode.insertBefore(s,t)}if(window.attachEvent){window.attachEvent("onload",l)}else{window.addEventListener("load",l,false)}})();
//   }
// }
